// src/Science/Grade11/Grade11ScienceMenu.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Grade11ScienceMenu() {
  const navigate = useNavigate();

  return (
    <div className="grade-selector-menu">
      <h2>Grade 11 Science</h2>
      <button className="button1" onClick={() => navigate("biology")}>Biology</button>
      <button className="button1" onClick={() => navigate("chemistry")}>Chemistry</button>
      <button className="button1" onClick={() => navigate("physics")}>Physics</button>
    </div>
  );
}
